import { useWadGTM } from '~/composables/useWadGTM'

export function useDeveloperSignup() {
  const config = useRuntimeConfig()
  const wadPlatformBaseUrl = config.public.wadPlatformBaseUrl
  const router = useRouter()
  const localePath = useLocalePath()
  const { pushGTMValues } = useWadGTM()

  const videoDetailsPageUrl = (video: any) => {
    return video ? localePath({name: 'videos-id-slug', params: { id: video.id, slug: video.slug }}) : null
  }

  const protectedVideoLoginRedirectUrl = (video: any) => {
    return `${wadPlatformBaseUrl}/en/user/login?redirect=${videoDetailsPageUrl(video)}`;
    //TODO: Update when login page is migrated
    //return `${localePath({ name: 'user-login' })}?redirect=${videoDetailsPageUrl(video)}`
  }

  const protectedVideoSignupRedirectUrl = (video: any) => {
    return `${wadPlatformBaseUrl}/en/developer/sign-up?redirect=${videoDetailsPageUrl(video)}`;
    //TODO: Update when login page is migrated
    //return `${localePath({ name: 'user-signup' })}?redirect=${videoDetailsPageUrl(video)}`
  }

  const getDeveloperSignupUrl = () => {
    return `${wadPlatformBaseUrl}/en/developer/sign-up`;
  }

  const navigateToSignupForSignupAsDeveloper = (isVideo: boolean) => {
    if (!isVideo) {
      pushGTMValues('developer-registration_registration-started-direct')
    } else {
      pushGTMValues('developer-registration_registration-started-video-details')
    }
    router.push(getDeveloperSignupUrl())
  }

  return {
    videoDetailsPageUrl,
    protectedVideoLoginRedirectUrl,
    protectedVideoSignupRedirectUrl,
    navigateToSignupForSignupAsDeveloper,
  }
}
